import styled from "styled-components";
import { NEAR_BLACK, NEAR_WHITE } from "../../config/colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  width: 569px;
  height: 368px;
`;

export const NavigateContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 1rem;
  border-bottom: 1px solid;
  color: ${NEAR_WHITE};
`;

export const CloseOption = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const CloseModal = styled(FontAwesomeIcon)`
  display: flex;
  cursor: pointer;
  color: ${NEAR_WHITE};
  padding-right: 2rem;
  font-size: 16px;
`;

export const InfoClose = styled.div`
  display: flex;
  padding: 0.3rem;
  justify-content: start;
  align-items: center;
  width: 569px;
  weight: 900;
  font-size: 24px;
`;

export const Title = styled.h2`
  padding-top: 3px;
  padding-left: 1rem;
  color: ${NEAR_WHITE};
  font-size: 24px;
`;

export const ModalFlex = styled.div`
  display: flex;
  padding-top: 25px;
`;

export const ModalImage = styled.img`
  height: 12rem;
  object-fit: cover;
  object-position: bottom;
  height: 138px;
  height: 138px;
  width: 220px;
  border-radius: 6px 6px 0px 0px;
  padding-left: 1rem;
`;

export const ModalInfoItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 16px;
`;

export const InfoItem = styled.div.attrs({ "data-testid": "infoItem" })`
  display: flex;
  padding: 0.3rem;
  justify-content: start;
  align-items: center;
  width: 266px;
`;

export const InfoText = styled.div`
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: ${NEAR_WHITE};
  padding-left: 0.5rem;
  font-size: 14px;
  line-height: 23.66px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 2rem;
  padding-top: 35px;
`;

export const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    background: NEAR_BLACK,
    border: "none",
    padding: "0",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
    zIndex: 5,
  },
};
